import React from "react";

export default function Logo({ className = "h-12", showText = true }) {
  return (
    <div className={`flex items-center gap-3 select-none ${className}`} data-testid="esha-logo">
      {/* Official ESHA Emblem — Fiery Golden Heart-Wings */}
      <img
        src="/assets/esha-emblem.png"
        alt="ESHA Emblem — Golden Heart Wings"
        className="h-full w-auto filter drop-shadow-[0_2px_12px_rgba(255,140,0,0.35)]"
        data-testid="esha-logo-emblem"
      />

      {/* Brand Text */}
      {showText && (
        <div className="flex flex-col leading-tight">
          <span
            className="font-serif text-2xl tracking-widest font-bold italic"
            style={{
              background: "linear-gradient(135deg, #00D2FF 0%, #0066FF 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            ESHA
          </span>
          <span className="font-sans text-[7px] sm:text-[8px] uppercase tracking-[0.18em] text-[#FF8C00] font-bold whitespace-nowrap">
            Eternal Soul Healing &amp; Awakening
          </span>
        </div>
      )}
    </div>
  );
}
